import { TicketStatus, type TicketWithComments } from '@rtkwlf/rendall';

import { useUserInfo } from '@apis/rendall/queries/use-user-info';
import { useCanManageAlertConfig } from '@packages/components/alert-configuration-rules/use-can-manage-alert-config/use-can-manage-alert-config';
import { useRendallOrganization } from 'ae-kernel/organizations/use-rendall-organization';

import { exclusiveStatuses, exclusiveTypes } from '../ticketAction.constants';

export const useTicketActionAuthorization = (ticket: TicketWithComments) => {
  const { currentOrganization } = useRendallOrganization();
  const { data: user } = useUserInfo();
  const canManageAlerts = useCanManageAlertConfig();

  const { status, type, requester, cc } = ticket;
  const {
    name = '',
    primaryContact = false,
    secondaryContact = false,
  } = user || {};

  const isTicketOpen = !exclusiveStatuses.includes(status);
  const canComment =
    (isTicketOpen || status === TicketStatus.Solved) &&
    (ticket.canReply || !!currentOrganization?.zendeskAllUsersCanComment);

  const canClose = !!(
    isTicketOpen &&
    !exclusiveTypes.includes(type) &&
    (requester === name ||
      cc.includes(name) ||
      primaryContact ||
      secondaryContact)
  );

  return { canClose, canComment, canManageAlerts };
};
